// extracted by mini-css-extract-plugin
module.exports = {"background":"_id__background__UtjXB","thumb":"_id__thumb__1vc__","switchBtn":"_id__switchBtn__Vrac5","yellowBtn":"_id__yellowBtn__tDrKu","disabledBtn":"_id__disabledBtn__cbJ97"};